<template>
    <div class="search-container">
        <input :class="{resultsOpen: searchResultsOpen}" ref="query" v-model="query"
               id="widget-search-box" type="text" placeholder="Search..." @keyup.enter="doSearch()"/>
        <search-results v-if="searchResultsOpen" :route="route" :results="results"></search-results>
    </div>
</template>

<script>
    var searchWidgetEmptyResults = {
        packages: [],
        archives: [],
        companies: [],
        people: [],
        pos: [],
        pis: [],
        sis: [],
        sos: []
    };

    export default {
        props: ['route'],
        data() {
            return {
                query: '',
                searchResultsOpen: false,
                searching:false,
                results: searchWidgetEmptyResults
            }
        },
        computed: {},
        watch:{
            query: function () {
                if (this.query != '') {
                    this.searchDebounce();
                }
            }
        },
        methods: {
            doSearch: function () {
                var that = this;
                if (this.searching) {
                    return;
                }

                this.searching = true;
                axios.get(appUrls.search, {params: {packages_only: true, query: this.query}}).then(function (response) {
                    that.searching = false;
                    that.results = response.data;
                    that.searchResultsOpen = true;
                });
            },
            searchDebounce: _.debounce(function () {
                this.doSearch();
            }, 500),
            resetSearchState: function () {
                this.searchResultsOpen = false;
                this.results = searchEmptyResults;
                this.query = '';
                this.searching = false;
            }
        },
        mounted() {

        }
    }
</script>

<style lang="scss" scoped>
    @import '../../sass/setup';
</style>
